import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { LocalStorageService } from '@core/services/local-storage.service';
import { HttpRequestService } from './http-request.service';
import { IspLoginResponse, IspModel } from '@core/models/isp.model';
import { CommunicationService } from './communication.service';
interface AuthState {
  authenticated: boolean;
  user: IspModel | null;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authenticationState: ReplaySubject<AuthState> = new ReplaySubject<AuthState>(
    1
  );
  constructor(
    private localStorageService: LocalStorageService,
    private httpRequestService: HttpRequestService,
    private communicationService: CommunicationService
  ) {
    this.communicationService.authLogout.subscribe((success) => {
      this.logout();
    });
    /**
     * Check Logged in Logic
     */
    const user: IspModel = localStorageService.getItem('user');
    const token = localStorageService.getItem('token', false);
    // const expiry = localStorageService.getItem('expiry');
    const authenticated = !!user && !!token;
    this.authenticationState.next({ authenticated, user: user || null });
  }
  public get authState(): Observable<AuthState> {
    return this.authenticationState as Observable<AuthState>;
  }
  public getLocalUser(): any {
    return this.localStorageService.getItem('user');
  }
  public setLocalUser(user: any) {
    this.localStorageService.setItem('user', user);
    this.authenticationState.next({ authenticated: true, user });
  }
  private setLocalToken(token: string) {
    this.localStorageService.setItem('token', token);
  }
  public async login(email: string, password: string) {
    return new Promise<any>((resolve, reject) => {
      this.httpRequestService
        .request('post', 'auth/login', { email, password })
        .subscribe(
          (success) => {
            const ispLoginResponse: IspLoginResponse = success.data;
            this.setLocalUser(ispLoginResponse.user);
            this.setLocalToken(ispLoginResponse.token);
            resolve(ispLoginResponse.user);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }
  public async logout() {
    /**
     * Replace with API Call
     */
    return new Promise<void>((resolve, reject) => {
      this.localStorageService.removeItem('user');
      this.localStorageService.removeItem('token');
      this.authenticationState.next({ authenticated: false, user: null });
      resolve();
    });
  }
}
